import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RequestStatus } from '../types';

import { UsersState, UserSuggestion } from './usersTypes';

const initialState: UsersState = {
  suggestions: [],
  status: 'none'
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setStatus(state, action: PayloadAction<RequestStatus>) {
      state.status = action.payload;
    },
    fetchSuggestionsSuccess(state, action: PayloadAction<UserSuggestion[]>) {
      state.suggestions = action.payload;
      state.status = 'success';
    },
    fetchSuggestionsError(state) {
      state.suggestions = [];
      state.status = 'error';
    },
    clearSuggestions(state) {
      state.suggestions = [];
    }
  }
});

export const usersReducer = usersSlice.reducer;

export const {
  setStatus,
  fetchSuggestionsSuccess,
  fetchSuggestionsError,
  clearSuggestions
} = usersSlice.actions;
